// NFR-5116: this module create study break data and save it to local and pinia store
import { WorkBreakData } from '@/models/studyBreakData';
import { useVersionStore } from "@/store/student/version_store";
import local_time from "@/util/datetime";
import {BREAK_DATA_VERSION} from '@/consts/break_data_version'
import {STUDY_TARGET_KIND} from '@/consts/study'

/**
 * 初期学習中断データを保存する関数
 * 
 * @param workStore - 学習データを管理するストア
 * @param question_set_id - 出題単位のID
 * @param correct_wrong_list - 正誤リスト（結果と進捗を含む）
 * @param created_at - データ作成日時（デフォルトは現在の時刻）
 * @param updated_at - データ更新日時（デフォルトはnull）
 * @param aborted_at - 中断日時（デフォルトはnull）
 * @param break_data_version - 中断データのバージョン（デフォルトはVERSION1）
 * @param study_target - 学習対象の種類（デフォルトは全質問）
 */
const saveInitialStudyBreakData = (
  workStore: any,
  question_set_id: number,
  correct_wrong_list: { result: boolean | null, progress: number }[],
  created_at = local_time(),
  updated_at = null,
  aborted_at = null,
  break_data_version = BREAK_DATA_VERSION.VERSION1,
  study_target = STUDY_TARGET_KIND.LEARN_ALL_THE_QUESTIONS,
  current_question_index: number = 0,
) => {
  // 中断状態である場合のみ処理を実行
  if(workStore.isInterrupt){
    const versionStore = useVersionStore()
    // 保存するデータ構造を定義
    const data = {
      question_set_id: question_set_id,
      data_created_at: created_at,
      data_aborted_at: aborted_at,
      data_updated_at: updated_at,
      app_version: versionStore.app_version,
      correct_wrong_list: correct_wrong_list,
      saved_answers: workStore.initialAnswer,
      study_target : study_target,
    }
    // バージョン2以上の場合はstudy_targetを設定
    if(break_data_version >= BREAK_DATA_VERSION.VERSION2){
      data.study_target = study_target
    }
    // WorkBreakDataオブジェクトを作成
    const breakData = WorkBreakData.fromData({break_data: workStore.interruptBreakData, temporary_data: data, break_data_version:break_data_version})
    // 学習中断データを保存
    workStore.saveStudyBreakData(breakData)
    // NFR-5891: fetch current question progress status
    const current_question_status = correct_wrong_list[current_question_index] ? correct_wrong_list[current_question_index].result : null
    // NFR-5891: if question not answered then reset question study start time
    if(current_question_status === null){
      workStore.saveQuestionStudyStartTime()
    }
  }
}

export {saveInitialStudyBreakData}
